import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { DEFAULT_PRODUCT_TYPES } from '@/modules/product/domain/product';
import ProductService from '@/modules/product/domain/ProductService';

function parseProductTypes(productTypes) {
  return typeof productTypes === 'string' ? JSON.parse(productTypes) : productTypes;
}

function findUnknownProductTypes(productTypes) {
  return productTypes.map((product) => product.productType).filter((type) => !ProductService.isValidProductType(type));
}

export default function ({ isDev, $config }, inject) {
  const { logger } = getLoggerService();
  let productTypes = $config.productTypes;

  if (!productTypes) {
    logger[isDev ? 'info' : 'error']('Using default product types as config is not provided');
    productTypes = DEFAULT_PRODUCT_TYPES;
  }

  try {
    const parsedProductTypes = parseProductTypes(productTypes);
    const unknownProductTypes = findUnknownProductTypes(parsedProductTypes);

    if (unknownProductTypes.length > 0) {
      logger.warn('Unknown product types detected', {
        unknownTypes: unknownProductTypes,
        source: 'process-product-types',
        service: 'reversehealth-web',
        timestamp: new Date().toISOString(),
      });
    }

    inject('productTypes', parsedProductTypes);
  } catch (error) {
    logger.error('Error processing product types', {
      error: error.message,
      source: 'process-product-types',
    });
    inject('productTypes', DEFAULT_PRODUCT_TYPES);
  }
}
